<template>
  <div class="w-full rounded-2xl overflow-hidden shadow-lg">
    <button
      @click="onDropdownClick"
      class="w-full bg-[#FFA500] py-3 px-5 font-bold flex justify-between items-center"
    >
      <span>{{ title }}</span>
      <Icon
        :icon="isOpen ? 'ant-design:up-outlined' : 'ant-design:down-outlined'"
        class="text-xl"
      />
    </button>

    <div v-if="isOpen" class="w-full bg-white">
      <div class="w-full p-5 flex items-center divide-x divide-gray-300 divide-solid">
        <div class="flex-1 text-center grid gap-3 justify-center">
          <span class="font-semibold">Current Length</span>

          <div
            class="grid place-items-center content-center h-32 w-32 rounded-full border-4 text-center"
            :class="type"
          >
            <span class="text-lg font-semibold">{{ sentenceLength }}</span>
            <span class="font-semibold">words</span>
          </div>

          <span class="font-semibold">{{ getTitle() }}</span>
        </div>

        <div class="flex-1 text-center grid gap-3 justify-center">
          <span class="font-semibold">Suggested Length</span>

          <div
            class="grid place-items-center content-center h-32 w-32 rounded-full border-4 text-center good"
          >
            <span class="text-lg font-semibold">8 to 17</span>
            <span class="font-semibold">words</span>
          </div>

          <span class="font-semibold">Ideal reference</span>
        </div>
      </div>

      <!-- <div class="w-full flex border-t border-t-gray-300">
        <button class="text-center flex flex-col flex-1 items-center p-3">
          <Icon icon="ant-design:delete-outlined" class="text-3xl mb-1" />
          <span class="text-xs">Dismiss</span>
        </button>
      </div> -->
    </div>
  </div>
</template>

<script lang="ts">
import { Icon } from '@iconify/vue';

export default {
  name: 'SentenceLengthDropdown',
  props: {
    isOpen: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    goldStandardAvg: {
      type: Number,
      required: true
    },
    goldStandardStd: {
      type: Number,
      required: true
    },
    sentenceLength: {
      type: Number,
      required: true
    },
    type: {
      type: String,
      required: true
    }
  },
  components: {
    Icon
  },
  methods: {
    onDropdownClick() {
      this.$emit('toggleDropdown');
      this.$emit('card-click');
    },
    getTitle() {
      if (this.type === 'bad') {
        return 'Very Difficult';
      } else if (this.type === 'fair') {
        return 'Fairly Difficult';
      } else {
        return 'Difficult';
      }
    }
  }
};
</script>

<style scoped>
.good,
.good + span {
  color: #52c41ad9 !important;
  border-color: #52c41ad9 !important;
}

.fair,
.fair + span {
  color: #ffc107 !important;
  border-color: #ffc107 !important;
}

.bad,
.bad + span {
  color: #d50000 !important;
  border-color: #d50000 !important;
}

.average,
.average + span {
  color: #ff9e59 !important;
  border-color: #ff9e59 !important;
}
</style>
